/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const prefix = 'sso-policy';

export const ssoPolicyModalBreadcrumbTitle = `${prefix}.ssoPolicyModalBreadcrumbTitle`;
export const authenticationRuleModalBreadcrumbTitle = `${prefix}.authenticationRuleModalBreadcrumbTitle`;
export const authorizationRuleModalBreadcrumbTitle = `${prefix}.authorizationRuleModalBreadcrumbTitle`;

export const ENGLISH = {
    [ssoPolicyModalBreadcrumbTitle]: 'SSO Policy',
    [authenticationRuleModalBreadcrumbTitle]: 'Authentication Rule',
    [authorizationRuleModalBreadcrumbTitle]: 'Authorization Rule',
};
